import { List, Map, fromJS } from 'immutable';
import { disableScroll, enableScroll } from '../prevent-scroll';

export const initialState = Map({
  isInitialized: false,
  menu: List([]),
  pages: Map({}),
  projectStubs: Map({}),
  projectListings: Map({}),
  projects: Map({}),
  showMenu: false,
  lightbox: null,
  error: null,
});


function toggleMenu(state, show) {
  const showMenu = show === null ? !state.get('showMenu') : show;

  if (showMenu) {
    disableScroll();
  } else {
    enableScroll();
  }

  return state.set('showMenu', showMenu);
}

function showLightbox(state, image) {
  if (image) {
    disableScroll();
  } else {
    enableScroll();
  }

  return state.set('lightbox', image);
}

function initialize(state, action) {
  const projectListings = {};
  action.projectListings.nodes.forEach((node) => {
    projectListings[node.slug] = {
      title: node.title,
      tag: node.fields.tag.value,
      intro: node.fields.intro.value,
    };
  });

  return state.merge({
    isInitialized: true,
    menu: fromJS(action.content.menus[0]),
    projectListings: fromJS(projectListings),
  });
}

function projectsLoaded(state, action) {
  return state.setIn(['projectStubs', action.tag], fromJS(action.projects));
}

function projectLoaded(state, action) {
  return state.setIn(['projects', action.project.slug], fromJS(action.project));
}

function pageLoaded(state, action) {
  return state.setIn(['pages', action.page.slug], fromJS(action.page));
}

function handleError(state, action) {
  return state.set('error', action.content);
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZED':
      return initialize(state, action);
    case 'PROJECTS_LOADED':
      return projectsLoaded(state, action);
    case 'PROJECT_LOADED':
      return projectLoaded(state, action);
    case 'PAGE_LOADED':
      return pageLoaded(state, action);
    case 'TOGGLE_MENU':
      return toggleMenu(state, action.show);
    case 'SHOW_LIGHTBOX':
      return showLightbox(state, action.image);
    case 'ERROR':
      return handleError(state, action);
    default:
      // console.log(`Unknown redux action '${action.type}'`);
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/reducer.js